/** Icone SVG inline in stile SF Symbols (tratto 1.8, ereditano currentColor). */
import type { ReactNode } from 'react';
import type { WeatherIcon } from '../lib/weather';

interface IconProps {
  size?: number;
  className?: string;
}

function Svg({ size = 20, className, children }: IconProps & { children: ReactNode }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
    >
      {children}
    </svg>
  );
}

export const IconCrosshair = (p: IconProps) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="6.5" />
    <path d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3" />
  </Svg>
);
export const IconLocate = (p: IconProps) => (
  <Svg {...p}>
    <path d="M21 3 10 13" />
    <path d="M21 3 14 21l-4-8-8-4z" />
  </Svg>
);
export const IconClear = (p: IconProps) => (
  <Svg {...p}>
    <path d="M6.5 6.5l11 11M17.5 6.5l-11 11" />
  </Svg>
);
export const IconSwap = (p: IconProps) => (
  <Svg {...p}>
    <path d="M7 4v13M7 17l-3-3M7 17l3-3" />
    <path d="M17 20V7M17 7l-3 3M17 7l3 3" />
  </Svg>
);
export const IconSun = (p: IconProps) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="4.2" />
    <path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.3 5.3l1.4 1.4M17.3 17.3l1.4 1.4M17.3 6.7l1.4-1.4M5.3 18.7l1.4-1.4" />
  </Svg>
);
export const IconMoon = (p: IconProps) => (
  <Svg {...p}>
    <path d="M20.5 14.5A8.5 8.5 0 1 1 9.5 3.5a7 7 0 0 0 11 11z" />
  </Svg>
);
export const IconSunset = (p: IconProps) => (
  <Svg {...p}>
    <path d="M17 17a5 5 0 0 0-10 0" />
    <path d="M12 3v6M9.5 6.5 12 9l2.5-2.5" />
    <path d="M3 17h2M19 17h2M5.5 10.5l1.4 1.4M18.5 10.5l-1.4 1.4M3 21h18" />
  </Svg>
);
export const IconCloud = (p: IconProps) => (
  <Svg {...p}>
    <path d="M7 18.5h10a4 4 0 0 0 .6-7.95A6 6 0 0 0 6.2 11.6 3.5 3.5 0 0 0 7 18.5z" />
  </Svg>
);
export const IconPartly = (p: IconProps) => (
  <Svg {...p}>
    <circle cx="9" cy="9" r="3.2" />
    <path d="M9 2.5v1.5M2.5 9H4M4.4 4.4l1 1M13.6 4.4l-1 1" />
    <path d="M10 20h8a3.5 3.5 0 0 0 .5-6.96A5 5 0 0 0 9.2 14 3 3 0 0 0 10 20z" />
  </Svg>
);
export const IconFog = (p: IconProps) => (
  <Svg {...p}>
    <path d="M4 9h13M7 13h13M4 17h11" />
  </Svg>
);
export const IconRain = (p: IconProps) => (
  <Svg {...p}>
    <path d="M7 15.5h10a4 4 0 0 0 .6-7.95A6 6 0 0 0 6.2 8.6 3.5 3.5 0 0 0 7 15.5z" />
    <path d="M9 18.5l-1 2.5M13 18.5l-1 2.5M17 18.5l-1 2.5" />
  </Svg>
);
export const IconSnow = (p: IconProps) => (
  <Svg {...p}>
    <path d="M12 3v18M4.2 7.5l15.6 9M4.2 16.5l15.6-9" />
  </Svg>
);
export const IconStorm = (p: IconProps) => (
  <Svg {...p}>
    <path d="M7 14.5h10a4 4 0 0 0 .6-7.95A6 6 0 0 0 6.2 7.6 3.5 3.5 0 0 0 7 14.5z" />
    <path d="M13 14l-2.5 4h3L11 22" />
  </Svg>
);
export const IconUV = (p: IconProps) => (
  <Svg {...p}>
    <circle cx="12" cy="13" r="3.5" />
    <path d="M12 4v2.5M4 13h2.5M17.5 13H20M6.3 7.3l1.8 1.8M17.7 7.3l-1.8 1.8" />
    <path d="M6 21h12" />
  </Svg>
);
export const IconHeat = (p: IconProps) => (
  <Svg {...p}>
    <path d="M10 14.5V5a2 2 0 1 1 4 0v9.5a3.5 3.5 0 1 1-4 0z" />
    <path d="M12 9v6" />
  </Svg>
);
export const IconCold = (p: IconProps) => (
  <Svg {...p}>
    <path d="M12 3v18M5 7.5l14 9M5 16.5l14-9M12 3l-2 2M12 3l2 2M12 21l-2-2M12 21l2-2" />
  </Svg>
);
export const IconShade = (p: IconProps) => (
  <Svg {...p}>
    <path d="M4 20h16M6 20V9l6-5 6 5v11" />
    <path d="M6 20l6-11v11z" fill="currentColor" stroke="none" opacity="0.35" />
  </Svg>
);
export const IconClock = (p: IconProps) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 7.5V12l3 2" />
  </Svg>
);
export const IconInfo = (p: IconProps) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 11v5.5" />
    <circle cx="12" cy="8" r="0.6" fill="currentColor" />
  </Svg>
);
export const IconExternal = (p: IconProps) => (
  <Svg {...p}>
    <path d="M18 13.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h5.5" />
    <path d="M15 3h6v6M21 3l-10 10" />
  </Svg>
);
export const IconCopy = (p: IconProps) => (
  <Svg {...p}>
    <rect x="9" y="9" width="11" height="11" rx="2.5" />
    <path d="M5 15H4.5A1.5 1.5 0 0 1 3 13.5v-9A1.5 1.5 0 0 1 4.5 3h9A1.5 1.5 0 0 1 15 4.5V5" />
  </Svg>
);
export const IconDownload = (p: IconProps) => (
  <Svg {...p}>
    <path d="M12 3v12M8 11l4 4 4-4M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" />
  </Svg>
);
export const IconShare = (p: IconProps) => (
  <Svg {...p}>
    <path d="M12 3v12M8 7l4-4 4 4" />
    <path d="M6 11H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-1" />
  </Svg>
);
export const IconWalk = (p: IconProps) => (
  <Svg {...p}>
    <circle cx="13" cy="4" r="1.6" />
    <path d="M12.5 7.5 10 13l-3 8M12.5 7.5 15 11l3.5 1M10 13l3 3 1 5M12.5 7.5 9 9 7.5 12" />
  </Svg>
);
export const IconSearch = (p: IconProps) => (
  <Svg {...p}>
    <circle cx="11" cy="11" r="6.5" />
    <path d="M16 16l4.5 4.5" />
  </Svg>
);
export const IconNavigate = (p: IconProps) => (
  <Svg {...p}>
    <path d="M12 2.5 19 21l-7-4-7 4z" fill="currentColor" stroke="none" />
  </Svg>
);
export const IconLayers = (p: IconProps) => (
  <Svg {...p}>
    <path d="M12 3 3 8l9 5 9-5z" />
    <path d="M3 12l9 5 9-5M3 16l9 5 9-5" />
  </Svg>
);
export const IconChevronDown = (p: IconProps) => (
  <Svg {...p}>
    <path d="M6 9l6 6 6-6" />
  </Svg>
);
export const IconChevronRight = (p: IconProps) => (
  <Svg {...p}>
    <path d="M9 6l6 6-6 6" />
  </Svg>
);
export const IconCheck = (p: IconProps) => (
  <Svg {...p}>
    <path d="M5 12.5l4.5 4.5L19 7.5" />
  </Svg>
);
export const IconStop = (p: IconProps) => (
  <Svg {...p}>
    <rect x="6" y="6" width="12" height="12" rx="2.5" fill="currentColor" stroke="none" />
  </Svg>
);
export const IconSparkles = (p: IconProps) => (
  <Svg {...p}>
    <path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z" />
    <path d="M19 16l.8 2.2L22 19l-2.2.8L19 22l-.8-2.2L16 19l2.2-.8z" />
  </Svg>
);
export const IconRecenter = (p: IconProps) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="3" />
    <path d="M12 3v3M12 18v3M3 12h3M18 12h3" />
    <circle cx="12" cy="12" r="8" />
  </Svg>
);
export const IconRoute = (p: IconProps) => (
  <Svg {...p}>
    <circle cx="6" cy="5" r="2.2" />
    <circle cx="18" cy="19" r="2.2" />
    <path d="M6 7.2V13a3 3 0 0 0 3 3h6a3 3 0 0 1 3 3" />
  </Svg>
);
export const IconMore = (p: IconProps) => (
  <Svg {...p}>
    <circle cx="6" cy="12" r="1.2" fill="currentColor" />
    <circle cx="12" cy="12" r="1.2" fill="currentColor" />
    <circle cx="18" cy="12" r="1.2" fill="currentColor" />
  </Svg>
);
export const IconWarning = (p: IconProps) => (
  <Svg {...p}>
    <path d="M12 3.5 21.5 20H2.5z" />
    <path d="M12 9.5v5M12 17.5v.5" />
  </Svg>
);

/** Icona meteo dal tipo semantico usato da weather.ts. */
export function WeatherGlyph({ icon, size = 20 }: { icon: WeatherIcon; size?: number }) {
  switch (icon) {
    case 'sun':
      return <IconSun size={size} />;
    case 'partly':
      return <IconPartly size={size} />;
    case 'cloud':
      return <IconCloud size={size} />;
    case 'fog':
      return <IconFog size={size} />;
    case 'rain':
      return <IconRain size={size} />;
    case 'snow':
      return <IconSnow size={size} />;
    case 'storm':
      return <IconStorm size={size} />;
    case 'moon':
      return <IconMoon size={size} />;
    case 'sunset':
      return <IconSunset size={size} />;
    case 'uv':
      return <IconUV size={size} />;
    case 'heat':
      return <IconHeat size={size} />;
    case 'cold':
      return <IconCold size={size} />;
  }
}
